import { render, staticRenderFns } from "./DocsApiUploadPage.vue?vue&type=template&id=75313ba9&"
import script from "../../../public/js/img/Discoveryjs/Docs/DocsApi.js?vue&type=script&lang=js&"
export * from "../../../public/js/img/Discoveryjs/Docs/DocsApi.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports